import { Component, OnInit, signal } from '@angular/core'
import { NavigationEnd, NavigationError, Router } from '@angular/router'
import { filter, map, take } from 'rxjs/operators'
import { BrandColorService } from './services/brand-color.service'
import { CustomerService } from './services/customer.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
    /**
     * A primeira navegação espera o `tenantAccessGuard` validar o ente; até lá mostra o carregamento.
     * Redirecionamento do guard cancela a navegação e começa outra, por isso só End/Error encerram.
     */
    readonly loading = signal(true)

    constructor(
        private readonly router: Router,
        private readonly customerService: CustomerService,
        private readonly brandColorService: BrandColorService
    ) {
    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd || event instanceof NavigationError),
            take(1)
        ).subscribe(() => this.loading.set(false))

        this.customerService.state().pipe(
            filter(state => !state.loading && !!state.customer.logoUrl),
            take(1),
            map(state => state.customer.logoUrl!)
        ).subscribe(logoUrl => {
            void this.brandColorService.applyFromUrl(logoUrl)
        })
    }
}
